import React from 'react';

import { Card, CardTitle, CardBody, UncontrolledTooltip } from 'reactstrap';

import utility from '../../services/utility';
import { PUBLISH_STATE, PUBLISH_STATE_ID } from '../../enums/publishState';

import KeyValueDisplay from '../../components/KeyValueDisplay/KeyValueDisplay';
import CopyButton from '../../components/Controls/CopyButton';

const MUX_STATE_MESSAGES = {
    [PUBLISH_STATE_ID.READY]: "Ready",
    [PUBLISH_STATE_ID.PREPARING]: "This file is still processing on Mux. Details will be incomplete until it finishes.",
    [PUBLISH_STATE_ID.ERRORED]: "Mux failed to process this file.",
    [PUBLISH_STATE_ID.DISABLED]: "This file has been disabled on Mux.",
    [PUBLISH_STATE_ID.DELETED]: "This file has been deleted from Mux.",
};

const MUX_STATE_DOT_COLOR = {
    [PUBLISH_STATE_ID.READY]: '#2dce89',
    [PUBLISH_STATE_ID.PREPARING]: '#fb6340',
};
const MUX_STATE_DOT_DEFAULT_COLOR = '#f5365c';

const MediaDetails = (props) => {
    const media = props.data;
    const isMuxReady = media?.state === PUBLISH_STATE_ID.READY;

    const detailsData = media ? {
        "Media Id": <><span className="mr-2">{media.mediaId}</span>{media.mediaId && <CopyButton id="button-copy-media-id" copyValue={media.mediaId} notificationMessage="Media Id copied to clipboard" />}</>,
        "State": (
            <>
                <span
                    id="mux-state-dot"
                    className="mr-2"
                    style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', backgroundColor: MUX_STATE_DOT_COLOR[media.state] || MUX_STATE_DOT_DEFAULT_COLOR, verticalAlign: 'middle', cursor: 'pointer' }}
                />
                <UncontrolledTooltip target="mux-state-dot">
                    {MUX_STATE_MESSAGES[media.state] || PUBLISH_STATE[media.state]}
                </UncontrolledTooltip>
                {PUBLISH_STATE[media.state]}
            </>
        ),
        "Created Date": utility.formatDateTimeString(media.createdDate),
        "Duration": isMuxReady ? utility.formatMillisecondTime(media.durationInMilliseconds) : "N/A",
        "Is Published": media.isPublished ? "Yes" : "No",
    } : null;

    return (
        <Card>
            <CardBody className="py-2">
                <CardTitle tag="h4" className="mb-2">Mux Details</CardTitle>
                {detailsData ?
                    <>
                        <KeyValueDisplay data={detailsData} />
                        <div className="col-12 my-1 text-sm d-flex align-items-center" style={{ minHeight: "1.75rem" }}>
                            <strong className="mr-2">Stream Url:</strong>
                            {media.streamUrl ? (
                                <>
                                    <a className="mr-2" href={media.streamUrl} target="_blank" rel="noopener noreferrer">
                                        {media.streamUrl}
                                    </a>
                                    <CopyButton id="button-copy-stream-url" copyValue={media.streamUrl} notificationMessage="Stream Url copied to clipboard" />
                                </>
                            ) : "N/A"}
                        </div>
                    </>
                    :
                    <p className="mb-0">File does not exist in Mux</p>}
            </CardBody>
        </Card>
    )
}

export default MediaDetails;
